import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(private http: HttpClient) { }

  getReports(postdata){
    return this.http.post(`${environment.baseUrl}/reportes/getReportsPDF.php`, postdata);
  }

  getArchivo(nombre){
    return this.http.get(`${environment.baseUrl}/reportes/getArchivo.php?report=${nombre}`);
  }

  getArchivoA(nombre){
    return this.http.post(`${environment.baseUrl}/reportes/getArchivoA.php`,nombre);
  }

  getAnexo(nombre){
    return this.http.post(`${environment.baseUrl}/reportes/getAnexo.php`,nombre);
  }

  getCarnet(nombre){
    return this.http.post(`${environment.baseUrl}/reportes/getCarnet.php`,nombre);
  }
}
